<template>
  <v-dialog :value="open" persistent max-width="350">
    <v-card color="#f0f0ef" class="home-form-container">
      <v-card-text
        v-if="editedItem !== null"
        class="home-form-container"
        style="text-align: left; padding: 4px 0 0 0"
      >
        <v-layout row style="margin-bottom: 10px">
          <input-field
            v-model="editedItem.sp_label"
            :label="$tc('Label', 1)"
            inputType="text"
            size="large"
          />
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text x-small @click="close">
          {{ $t("Cancel") }}
        </v-btn>
        <v-btn
          x-small
          color="accent"
          style="margin-right: 10px"
          @click="applyChanges"
        >
          {{ $t("ApplyChanges") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";

export default {
  name: "ClosureFormSplittersTabSplitterEditionForm",

  components: { InputField },

  props: {
    open: {
      type: Boolean,
      required: true
    },

    originalItem: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      editedItem: null
    };
  },

  mounted() {
    this.setItemToEdit();
  },

  watch: {
    originalItem() {
      this.setItemToEdit();
    }
  },

  methods: {
    setItemToEdit() {
      this.editedItem = Object.assign({}, this.originalItem);
    },

    applyChanges() {
      this.$emit("edit", this.editedItem);
      this.close();
    },

    close() {
      this.$emit("close");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splitters/SplitterEditionForm.vue